import throttle from 'lodash/throttle';
export default class BootstrapService {

  [x: string]: any;

  static $inject = ['InstanceConfigService', 'AuthService', 'NumbersStateService', 'PlansStateService', 'ipUserInfo', 'BalanceNotificationsService', 'LiveChat', 'AmplitudeService', 'ProfitwellService', 'WidgetService', 'StripeApiKeyInjector', 'LastStateService', 'ng2BootstrapService', '$q', '$state', 'Router'];

  constructor(InstanceConfigService, AuthService, NumbersStateService, PlansStateService, ipUserInfo, BalanceNotificationsService, LiveChat,
              AmplitudeService, ProfitwellService, WidgetService, StripeApiKeyInjector, LastStateService, ng2BootstrapService, $q, $state, Router) {
    this.InstanceConfigService = InstanceConfigService;
    this.AuthService = AuthService;
    this.NumbersStateService = NumbersStateService;
    this.PlansStateService = PlansStateService;
    this.ipUserInfo = ipUserInfo;
    this.BalanceNotificationsService = BalanceNotificationsService;
    this.LiveChat = LiveChat;
    this.AmplitudeService = AmplitudeService;
    this.ProfitwellService = ProfitwellService;
    this.WidgetService = WidgetService;
    this.StripeApiKeyInjector = StripeApiKeyInjector;
    this.$state = $state;
    this.LastStateService = LastStateService;
    this.ng2BootstrapService = ng2BootstrapService;
    this.router = Router;

    this.bootstrapCompeted = $q.defer();
  }

  blockedState(StripeElementsProvider) {
    return this.initInstanceConfig(StripeElementsProvider)
      .then(() => this.AuthService.checkUser())
      .then(() => this.LiveChat.initUserInfo(this.AuthService.currentUser()))
      .then(() => this.ipUserInfo.isReady())
      .then(() => this.BalanceNotificationsService.notifyIfRechargeFailed())
      .then(() => {
        this.AmplitudeService.setUser(this.AuthService.currentUser());
        this.AmplitudeService.logEvent('Panel: Blocked state');
        this.bootstrapCompeted.resolve(true);
      });
  }

  chooseAccountState() {
    this.AmplitudeService.logEvent('Panel: Choose account state');
    this.bootstrapCompeted.resolve(true);
  }

  async fullAppState(StripeElementsProvider) {
    await this.AuthService.checkUser();
    return throttle(() => this.channelsBootstrap(StripeElementsProvider), 1000)();
  }

  private channelsBootstrap(StripeElementsProvider): Promise<any> {
    return throttle(() => this.initInstanceConfig(StripeElementsProvider)
      .then(() => this.PlansStateService.checkPlan())
      .then(() => this.LiveChat.initUserInfo(this.AuthService.currentUser()))
      .then(() => this.NumbersStateService.fetchNumbersAndBlockingStatus())
      .then(() => this.LastStateService.restoreLastState({ defaultStateToGo: 'app.dashboard' }))
      .then(() => {
        this.AmplitudeService.setUser(this.AuthService.currentUser());
        this.AmplitudeService.logEvent('Panel: Full app state');
        this.ng2BootstrapService.boostrapComplete();
        return this.bootstrapCompeted.resolve(true);
      })
      .catch(error => {
        if (error && error.redirectTo) {
          this.AmplitudeService.logEvent('Panel: Cannot fully load app - redirect required', {
            redirectTo: error.redirectTo,
            type: error.type
          });
          // TODO: cannot remove the $state here yet; make it as a next step of cleanup
          console.log('error.redirectTo: ', error.redirectTo)
          this.$state.go(error.redirectToState, {}, { reload: true });
          this.router.navigateByUrl(error.redirectTo);
        } else {
          throw error;
        }
      }), 10000)();
  }

  isBootstrapCompeted(): Promise<any> {
    return this.bootstrapCompeted.promise;
  }

  private initInstanceConfig(StripeElementsProvider): Promise<any> {
    return this.InstanceConfigService.get().$promise
      .then(config => {
        this.StripeApiKeyInjector.setStripePublishableApiKey(config.stripeApiKey);
        StripeElementsProvider.setAPIKey(config.stripeApiKey);
      });
  }
}
